<script>
import { widgetPlanningTabProps, useWidgetPlanningTab } from "./mixin";
import FormSelect from "@/components/molecules/form-select";
import FormSelectOption from "@/components/molecules/form-select/form-select-option";
import Divider from "@/components/atoms/divider";
import LinkTo from "@/components/atoms/link-to";
import ButtonIcon from "@/components/molecules/button-icon";
import Planning from "@/containers/planning";
import PlanningCommunesSelector from "@/containers/planning/planning-communes-selector";
import WidgetPlanningTabClickCollect from "@/containers/widgetPlanningTabClickCollect";

export default {
  name: "WidgetPlanningTab",
  props: { ...widgetPlanningTabProps() },
  components: {
    FormSelect,
    Divider,
    FormSelectOption,
    LinkTo,
    ButtonIcon,
    Planning,
    PlanningCommunesSelector,
    WidgetPlanningTabClickCollect
  },
  setup(props) {
    const {
      MODES_DE_COMMANDE,
      commune,
      dispoPremierCreneau,
      finDispoPremierCreneau,
      currentServiceId,
      services,
      currentService,
      hasGps,
      gpsLink,
      selectCommune,
      resetCommune,
      planningDisplayed,
      planningError
    } = useWidgetPlanningTab(props);

    const formSelect = ref(null);

    return {
      MODES_DE_COMMANDE,
      commune,
      dispoPremierCreneau,
      finDispoPremierCreneau,
      currentServiceId,
      services,
      currentService,
      hasGps,
      gpsLink,
      selectCommune,
      resetCommune,
      planningDisplayed,
      planningError,
      formSelect
    };
  }
};
</script>

<template>
  <div v-if="modeCommande.type ==='CC'">
    <WidgetPlanningTabClickCollect
      :from-planning="true"
      :magasin="magasin"
    />
  </div>
  <div v-else>
    <ButtonIcon
      v-if="modeCommande.planning_par_commune && commune"
      link
      icon-name="arrow-left"
      icon-size="xs"
      class="u-mb-sm"
      @click="resetCommune()"
    >
      Retour à la liste des communes
    </ButtonIcon>
    <div
      v-if="services.length > 1"
      class="u-p-sm"
    >
      <label :for="formSelect?.$el?.id">
        <p class="u-font-18 u-font-secondary u-font-700 u-mb-xs">
          {{ modeCommande.type === MODES_DE_COMMANDE.lc ? "Votre partenaire de livraison" : "Votre point de retrait" }}
        </p>
      </label>
      <FormSelect
        ref="formSelect"
        v-uid
        v-model="currentServiceId"
        class="u-mb-xs"
      >
        <FormSelectOption
          v-for="service in services"
          :key="service.id"
          :value="service.id"
        >
          {{ service.description }}
        </FormSelectOption>
      </FormSelect>
      <p
        v-if="currentService && currentService.adresse"
        class="u-font-15 u-mb-xs"
      >
        {{ currentService.adresse }} ({{ currentService.details }})
      </p>

      <LinkTo
        v-if="hasGps"
        :href="gpsLink"
        target="_blank"
        class="u-mb-md"
      >
        Voir le plan d'accès
      </LinkTo>
      <Divider dotted />
    </div>
    <div class="u-text-center">
      <p
        v-if="modeCommande.planning_par_commune && commune"
        class="u-color-primary u-font-17 u-mb-sm"
      >
        {{ commune.attributes.nom_commune }} ({{ commune.attributes.code_postal }})
      </p>
      <div
        v-if="!modeCommande.planning_par_commune || (modeCommande.planning_par_commune && commune)"
        class="u-text-center u-mb-md"
      >
        <p
          v-if="dispoPremierCreneau"
          class="u-font-15"
        >
          Prochain créneau disponible : <span class="u-font-500">{{ dispoPremierCreneau }}</span>
        </p>
        <p
          v-if="finDispoPremierCreneau"
          class="u-font-15"
        >
          Commandez avant : <span class="u-font-500">{{ finDispoPremierCreneau }} pour en bénéficier</span>
        </p>
      </div>
    </div>
    <template v-if="modeCommande.planning_par_commune && !commune">
      <p class="u-mb-md u-text-center u-font-15">
        Sélectionnez une commune pour connaître le prochain créneau disponible
      </p>
      <PlanningCommunesSelector @communeSelected="selectCommune" />
    </template>

    <Planning
      v-if="currentServiceId && (!modeCommande.planning_par_commune || commune)"
      :selectable="false"
      :creneaux-full-width="modeCommande.planning_par_commune"
      :service-id="currentServiceId"
      :code-postal="(modeCommande.planning_par_commune && commune) ? commune.attributes.code_postal : null"
      :code-insee="(modeCommande.planning_par_commune && commune) ? commune.attributes.code_insee : null"
      @success="planningDisplayed"
      @error="planningError"
    />
  </div>
</template>

<style lang="scss" scoped>
</style>
